module.exports = __webpack_public_path__ + "img/img-32.8c66e533.png";